export const tutorialVideoLinks = {
  uploadFirstBook: 'https://youtu.be/pyjYfmUPoiA',
  manageBooksTour: 'https://youtu.be/xCJtRkOWz6s',
  originalDashboardMetadata: 'https://youtu.be/3jTIwJg5LKk',
  originalProofread: 'https://youtu.be/CUXlGRSHXV8',
  chapterLevelControls: 'https://youtu.be/PTH7wTayLPo',
  chapterEditing: 'https://youtu.be/fPyt_h-ciUo',
  glossary: 'https://youtu.be/JzIgCCP-zmA',
  simpleWorkflow: 'https://youtu.be/eyPS4tOYG4E',
  advancedTranslation: 'https://youtu.be/8gM6Gd8Eon4',
  translatedDashboard: 'https://youtu.be/E2jJtXwmKu0',
  translatedProofread: 'https://youtu.be/0YZGhxz_eNA',
} as const;

export const supportTutorialsPath = '/support?tab=tutorials';
